export const debounce = <T extends (...args: any[]) => ReturnType<T>>(
  callback: T,
  timeout: number,
): ((...args: Parameters<T>) => void) => {
  let timer: ReturnType<typeof setTimeout>;

  return (...args: Parameters<T>) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      callback(...args);
    }, timeout);
  };
};

export const delay = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));

export const executeWithTimelimit = async <T>(fn: Promise<T>, limit: number): Promise<T> => {
  let timeout;
  const timeoutPromise = new Promise<T>((_resolve, reject) => {
    timeout = setTimeout(() => {
      reject("Timeout");
    }, limit);
  });

  const response = await Promise.race([fn, timeoutPromise]);

  if (timeout) {
    clearTimeout(timeout);
  }
  return response;
};
